<template>
  <div>
    <div class="main-top">
      <carousel
        class="p-5"
        :per-page="perPage"
        autoplay
        loop
        :pagination-enabled="paginationEnabled"
        :scroll-per-page="scrollPerPage"
        :navigation-pre-label="abc"
        :navigation-next-label="abc"
      >
        <slide v-for="item in slideItems" v-bind:key="item.nameTag">
          <div>
            <img v-bind:src="item.icon" @click="gotoDetail(item.nameTag)" />
            <p class="mt-2">
              <a style="outline: none;" @click="gotoDetail(item.nameTag)">{{item.nameShow}}</a>
            </p>
          </div>
        </slide>
      </carousel>
    </div>
    <mdb-container class="mt-5 mb-5" style="background-color:#FFFFFF;">
      <mdb-row>
        <mdb-col col="9">
          <h3 class="font-weight-bold mt-4 mb-3 p-0">
            <strong>All Games</strong>
          </h3>
          <hr class="my-2" />
          <mdb-row class="mdb-lightbox">
            <mdb-col md="4" v-for="item in slideItems" v-bind:key="item.nameTag">
              <img class="img-fluid" @click="gotoDetail(item.nameTag)" v-bind:src="item.icon" />
              <p>
                <a style="outline: none;" @click="gotoDetail(item.nameTag)">{{item.nameShow}}</a>
              </p>
            </mdb-col>
          </mdb-row>
        </mdb-col>
        <mdb-col col="3">
          <h5 class="font-weight-bold mt-5 p-0">
            <strong>Platform</strong>
          </h5>
          <hr class="my-2" />
          <div class="custom-control custom-checkbox p-2 pl-5">
            <input type="checkbox" class="custom-control-input" />
            <label class="custom-control-label" for="defaultUnchecked">Android</label>
          </div>
          <div class="custom-control custom-checkbox p-2 pl-5">
            <input type="checkbox" class="custom-control-input" />
            <label class="custom-control-label" for="defaultUnchecked">iOS</label>
          </div>
          <h5 class="font-weight-bold mt-4 p-0">
            <strong>Genre</strong>
          </h5>
          <hr class="my-2" />
          <div class="custom-control custom-checkbox p-2 pl-5">
            <input type="checkbox" class="custom-control-input" />
            <label class="custom-control-label" for="defaultUnchecked">Casual</label>
          </div>
          <div class="custom-control custom-checkbox p-2 pl-5">
            <input type="checkbox" class="custom-control-input" />
            <label class="custom-control-label" for="defaultUnchecked">Educational</label>
          </div>
          <div class="custom-control custom-checkbox p-2 pl-5">
            <input type="checkbox" class="custom-control-input" />
            <label class="custom-control-label" for="defaultUnchecked">Puzzle</label>
          </div>
          <div class="custom-control custom-checkbox p-2 pl-5">
            <input type="checkbox" class="custom-control-input" />
            <label class="custom-control-label" for="defaultUnchecked">Racing</label>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import {
  mdbContainer,
  mdbRow,
  mdbCol
} from "mdbvue";
export default {
  components: {
    Carousel,
    Slide,
    mdbContainer,
    mdbRow,
    mdbCol
  },
  name: "Game",
  data() {
    return {
      slides: [
        "lionandmouse",
        "catstory",
        "circlebreak",
        "crazycandybomb",
        "fishcrushcharminocean",
        "jewelsmaniacrush",
        "coloringcreative",
        "candyprincess",
        "sweetcandyforest"
      ],
      slideItems: [],
      perPage: 5,
      scrollPerPage: false,
      paginationEnabled: false,
      navigationEnabled: true,
      abc: "<i icon='chevron-left'></i>"
    };
  },
  methods: {
    gotoDetail: function(nameTag) {
      this.$router.push({
        path: "detail",
        query: { name: nameTag }
      });
    }
  },
  computed: { ...mapGetters(["getGameByName"]) },
  created: function() {
    this.slideItems = this.getGameByName(this.slides);
  }
};
</script>
<style scoped>
.main-top {
  background: #212728;
  color: #fff;
}
</style>